import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import "./index.css";
import { get } from "services/http";
import { ConfigurationDetails } from "features/types";
import Form from "./Form";

export interface StripeCard {
  address_city: string | null;
  address_country: string | null;
  address_line1: string | null;
  address_line1_check: string | null;
  address_line2: string | null;
  address_state: string | null;
  address_zip: string;
  address_zip_check: string;
  brand: string;
  country: string;
  cvc_check: string;
  dynamic_last4: string | null;
  exp_month: number;
  exp_year: number;
  funding: string;
  id: string;
  last4: string;
  name: null;
  object: string;
  tokenization_method: null;
}
export interface StripeToken {
  card: StripeCard;
  client_ip: string;
  created: string;
  id: string;
  livemode: boolean;
  object: string;
  type: string;
  used: boolean;
}

export interface StripeTokenResponse {
  nameOnCard: string;
  postalCode: string;
  token: StripeToken;
}

export interface StripeTokenError {
  error: {
    code: string;
    message: string;
    type: string;
  };
}

export interface StripePaymentFormProps {
  btnText?: string;
  onTokenReceived: (
    error: StripeTokenError | undefined,
    response?: StripeTokenResponse
  ) => void;
  disabled?: boolean;
  loading?: boolean;
  showAgreementText?: boolean;
}

// https://github.com/stripe/stripe-js/issues/43#issuecomment-643840075
let stripePromise: any;
const getStripe = () => {
  if (!stripePromise) {
    stripePromise = get({
      url: `/configuration`,
    })
      .then((data) => {
        const { billingProviderPublicKey } = data as ConfigurationDetails;
        return billingProviderPublicKey;
      })
      .then((billingProviderPublicKey) => loadStripe(billingProviderPublicKey));
  }
  return stripePromise;
};

const StripePaymentForm: React.FC<StripePaymentFormProps> = (props) => {
  return (
    <Elements stripe={getStripe()}>
      <Form {...props} />
    </Elements>
  );
};

export default StripePaymentForm;
